(function () {
  'use strict';

  var scriptEl = document.querySelector('script[data-caption-src][src*="a11y-lighthouse-fixes"]');
  var CAPTION_SRC = scriptEl && scriptEl.dataset.captionSrc;

  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]';

  var RTL_LANGS = { he: true, ar: true, fa: true, ur: true, yi: true };

  function ensureVideoCaptions(video) {
    if (!CAPTION_SRC || !video || video.nodeName !== 'VIDEO') return;
    if (video.querySelector('track[kind="captions"]')) return;

    var track = document.createElement('track');
    track.kind = 'captions';
    track.srclang = 'en';
    track.label = 'English';
    track.src = CAPTION_SRC;
    video.appendChild(track);
  }

  var INVALID_ROLES = {
    'expand-benefits-button': 'button',
    'see-details-button': 'button'
  };

  function fixInvalidRoles(root) {
    Object.keys(INVALID_ROLES).forEach(function (invalidRole) {
      root.querySelectorAll('[role="' + invalidRole + '"]').forEach(function (el) {
        el.setAttribute('role', INVALID_ROLES[invalidRole]);
        if (!el.hasAttribute('tabindex') && el.tagName !== 'BUTTON') {
          el.setAttribute('tabindex', '0');
        }
      });
    });
  }

  function fixSummaryRoles(root) {
    root.querySelectorAll('details > summary[role="button"]').forEach(function (el) {
      el.removeAttribute('role');
    });
  }

  function fixRtlLanguages(root) {
    root.querySelectorAll('[lang]').forEach(function (el) {
      var lang = (el.getAttribute('lang') || '').toLowerCase().split('-')[0];
      if (RTL_LANGS[lang] && !el.hasAttribute('dir')) {
        el.setAttribute('dir', 'rtl');
      }
    });
  }

  function fixLinkAccessibleNames(root) {
    root.querySelectorAll('a[aria-label]').forEach(function (el) {
      var label = el.getAttribute('aria-label') || '';
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var href = el.getAttribute('href') || '';
      if (!text) return;
      if (label === href || label.charAt(0) === '/' || label === '#MainContent' || label === '#') {
        el.removeAttribute('aria-label');
      }
    });
  }

  function isBadImageAlt(alt) {
    if (!alt || !String(alt).trim()) return true;
    alt = String(alt).trim();
    if (/^https?:\/\//i.test(alt) || alt.indexOf('//') === 0) return true;
    if (alt.indexOf('/cdn/') !== -1 || alt.indexOf('/assets/') !== -1 || alt.indexOf('/files/') !== -1) return true;
    if (/\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(alt)) return true;
    return false;
  }

  function isPlaceholderAlt(alt) {
    if (!alt || !String(alt).trim()) return false;
    var normalized = String(alt).trim().toLowerCase();
    return /placeholder|spacer|\bpicture\b|\bphoto\b|^image$|^img$|^block image$|^slide image$|^mobile slide image$|^sale tag$/.test(
      normalized
    );
  }

  function filenameFromSrc(src) {
    if (!src) return '';
    var path = String(src).split('?')[0];
    var parts = path.split('/');
    var name = parts[parts.length - 1] || '';
    name = name.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ').trim();
    return name;
  }

  function getProductTitle() {
    var el = document.querySelector('.product-single__title, .product__title h1, h1.product-single__title, [data-product-title]');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function altFromImageContext(img) {
    var featureBlock = img.closest('.custom__item-inner, .features');
    if (featureBlock) {
      var heading = featureBlock.querySelector('h4, h5');
      if (heading && heading.textContent.trim()) return heading.textContent.replace(/\s+/g, ' ').trim();
    }
    var dataAltEl = img.closest('[data-alt]');
    if (dataAltEl) {
      var dataAlt = (dataAltEl.getAttribute('data-alt') || '').replace(/^alt--/, '').replace(/-/g, ' ').trim();
      if (dataAlt && !/mod/i.test(dataAlt)) return dataAlt;
    }
    return '';
  }

  function getPageTitle() {
    var h1 = document.querySelector('h1.main-page-title, h1.page-title, .main-page-title, main h1, h1');
    if (h1 && h1.textContent.trim()) return h1.textContent.replace(/\s+/g, ' ').trim();
    var title = (document.title || '').split('|')[0].split('–')[0].split('-')[0].trim();
    return title || '';
  }

  function deriveImageAlt(img) {
    var contextAlt = altFromImageContext(img);
    var productTitle = getProductTitle();
    var pageTitle = getPageTitle();
    var filename = filenameFromSrc(img.getAttribute('src') || img.getAttribute('data-src') || '');
    if (productTitle && contextAlt) return productTitle + ' - ' + contextAlt;
    if (productTitle) {
      if (filename && filename.length > 2 && !/^[a-f0-9]{16,}$/i.test(filename)) {
        return productTitle + ' - ' + filename.charAt(0).toUpperCase() + filename.slice(1);
      }
      return productTitle;
    }
    if (pageTitle && contextAlt) return pageTitle + ' - ' + contextAlt;
    if (pageTitle) return pageTitle;
    if (contextAlt) return contextAlt;
    if (filename && filename.length > 2) return filename.charAt(0).toUpperCase() + filename.slice(1);
    return 'Image';
  }

  function fixBadImageAlts(root) {
    root.querySelectorAll('img').forEach(function (img) {
      if (window.lemsIsKlaviyoSubtree && window.lemsIsKlaviyoSubtree(img)) return;
      if (!img.hasAttribute('alt') || img.getAttribute('alt') === null) {
        img.setAttribute('alt', deriveImageAlt(img));
        return;
      }
      var alt = img.getAttribute('alt');
      if (alt === null || /^\s+$/.test(alt) || isBadImageAlt(alt) || isPlaceholderAlt(alt)) {
        img.setAttribute('alt', deriveImageAlt(img));
      }
    });
  }

  function fixPlaceholderImageAlts(root) {
    fixBadImageAlts(root);
  }

  function getFocusableDescendants(container) {
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(function (el) {
      return el !== container;
    });
  }

  function fixPresentationalRoleConflicts(root) {
    root.querySelectorAll('[role="button"]').forEach(function (el) {
      if (el.tagName === 'BUTTON') return;

      if (el.tagName === 'A' && el.getAttribute('href')) {
        el.removeAttribute('role');
        return;
      }

      if (!getFocusableDescendants(el).length) return;

      el.removeAttribute('role');
      if (el.getAttribute('tabindex') === '0' && !el.matches('.video-title-wrapper, #video-play-button')) {
        el.removeAttribute('tabindex');
      }
    });

    root.querySelectorAll('summary[role="button"]').forEach(function (el) {
      el.removeAttribute('role');
    });
  }

  function fixFieldsetLegends(root) {
    root.querySelectorAll('fieldset').forEach(function (fieldset) {
      if (fieldset.querySelector(':scope > legend')) return;

      var legend = document.createElement('legend');
      legend.className = 'visually-hidden';

      var label = fieldset.getAttribute('aria-label') || fieldset.getAttribute('data-label') || '';
      if (!label) {
        var context = fieldset.closest('.facet-filter-detail, .js-filter, details, .facets__disclosure');
        if (context) {
          var titleEl = context.querySelector('.js-filter-label, .facets__summary > div > span, summary > div > span');
          if (titleEl) label = titleEl.textContent.replace(/\s+/g, ' ').trim();
        }
      }

      legend.textContent = label || 'Options';
      fieldset.insertBefore(legend, fieldset.firstChild);
    });
  }

  function bindAutoplayVideoPause(btn, video) {
    if (!btn || !video || btn.hasAttribute('data-lems-video-pause-bound')) return;
    btn.setAttribute('data-lems-video-pause-bound', 'true');
    if (!btn.getAttribute('aria-controls') && video.id) {
      btn.setAttribute('aria-controls', video.id);
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      if (video.paused) {
        video.play();
        btn.setAttribute('aria-label', 'Pause video');
        if (btn.classList.contains('split-hero-banner__icon')) btn.textContent = '❚❚';
      } else {
        video.pause();
        btn.setAttribute('aria-label', 'Play video');
        if (btn.classList.contains('split-hero-banner__icon')) btn.textContent = '▶';
      }
    });
  }

  function fixAutoplayVideoPauseControls(root) {
    root.querySelectorAll('button[aria-controls], [role="button"][aria-controls]').forEach(function (btn) {
      var videoId = btn.getAttribute('aria-controls');
      if (!videoId) return;
      var video = document.getElementById(videoId);
      if (video && video.nodeName === 'VIDEO') bindAutoplayVideoPause(btn, video);
    });

    root.querySelectorAll('video[autoplay]').forEach(function (video) {
      if (video.hasAttribute('controls')) return;
      if (!video.id) {
        video.id = 'lems-autoplay-video-' + Math.random().toString(36).slice(2, 9);
      }

      var btn =
        video.parentElement &&
        video.parentElement.querySelector('[aria-controls="' + CSS.escape(video.id) + '"]');
      if (btn) {
        bindAutoplayVideoPause(btn, video);
        return;
      }

      if (video.parentElement && video.parentElement.querySelector('[data-lems-video-pause-injected]')) return;

      var pauseBtn = document.createElement('button');
      pauseBtn.type = 'button';
      pauseBtn.className = 'lems-autoplay-video-pause visually-hidden';
      pauseBtn.setAttribute('data-lems-video-pause-injected', 'true');
      pauseBtn.setAttribute('aria-controls', video.id);
      pauseBtn.setAttribute('aria-label', 'Pause video');
      pauseBtn.textContent = 'Pause video';
      video.parentElement.appendChild(pauseBtn);
      bindAutoplayVideoPause(pauseBtn, video);
    });
  }

  function fixInvalidListStructure(root) {
    root.querySelectorAll('ul[role="list"], ul.product-single__thumbnails-grid, ul.fixed_images, ul.mobile_gallery_slider, ul.images-auto').forEach(function (ul) {
      Array.prototype.slice.call(ul.children).forEach(function (child) {
        if (child.tagName === 'LI') return;
        if (child.classList && child.classList.contains('product__media-icon')) {
          ul.parentElement.insertBefore(child, ul);
        }
      });
    });
  }

  function getButtonAccessibleName(btn) {
    if (!btn || btn.nodeType !== 1) return '';

    var ariaLabel = btn.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.replace(/\s+/g, ' ').trim()) return ariaLabel.trim();

    var labelledBy = btn.getAttribute('aria-labelledby');
    if (labelledBy) {
      var parts = labelledBy.split(/\s+/).map(function (id) {
        var el = document.getElementById(id);
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
      }).filter(Boolean);
      if (parts.length) return parts.join(' ');
    }

    var title = btn.getAttribute('title');
    if (title && title.replace(/\s+/g, ' ').trim()) return title.trim();

    var value = btn.getAttribute('value');
    if (value && value.replace(/\s+/g, ' ').trim()) return value.trim();

    var srOnly = btn.querySelector('.visually-hidden, .icon__fallback-text, .oke-a11yText');
    if (srOnly && srOnly.textContent.replace(/\s+/g, ' ').trim()) {
      return srOnly.textContent.replace(/\s+/g, ' ').trim();
    }

    if (!btn.classList.contains('visually-hidden')) {
      var text = btn.textContent.replace(/\s+/g, ' ').trim();
      if (text) return text;
    }

    return '';
  }

  function buttonHasAccessibleName(btn) {
    return !!getButtonAccessibleName(btn);
  }

  function deriveButtonLabel(btn) {
    if (btn.classList.contains('lems-gif-pause')) {
      return btn.dataset.lemsGifPaused === 'true' ? 'Play animation' : 'Pause animation';
    }
    if (btn.classList.contains('slick-prev')) return 'Previous';
    if (btn.classList.contains('slick-next')) return 'Next';
    if (btn.closest('.slick-dots')) {
      var li = btn.closest('li');
      if (li && li.parentElement) {
        var index = Array.prototype.indexOf.call(li.parentElement.children, li) + 1;
        if (index > 0) return 'Go to slide ' + index;
      }
      return 'Go to slide';
    }
    if (btn.classList.contains('product__media-toggle')) return 'Open media';
    if (btn.classList.contains('deferred-media__poster')) return 'Play video';
    if (btn.classList.contains('share-button__button')) return 'Share';
    if (btn.classList.contains('search-modal__close-button')) return 'Close search';
    if (btn.classList.contains('modal__close-button')) return 'Close';
    if (btn.classList.contains('js-also-slider-prev')) return 'Previous related product';
    if (btn.classList.contains('js-also-slider-next')) return 'Next related product';
    if (btn.id === 'lcly-button-buy' || btn.classList.contains('lcly-primary-trigger')) {
      return (
        btn.getAttribute('title') ||
        (btn.querySelector('span') && btn.querySelector('span').textContent.replace(/\s+/g, ' ').trim()) ||
        'Find it locally'
      );
    }
    if (btn.classList.contains('lcly-location-prompt-link')) return 'Change location';
    if (btn.id === 'lcly-iframe-closer-0') return 'Close retailers';
    if (btn.id === 'lcly-iframe-outer-0') return 'Close retailer finder';
    if (btn.classList.contains('lcly-dealer')) {
      var dealerName = btn.querySelector('.lcly-dealer-name');
      if (dealerName && dealerName.textContent.replace(/\s+/g, ' ').trim()) {
        return dealerName.textContent.replace(/\s+/g, ' ').trim();
      }
    }
    if (btn.classList.contains('lcly-buy-online-option')) {
      var optionName = btn.querySelector('.lcly-buy-online-option-name');
      if (optionName && optionName.textContent.replace(/\s+/g, ' ').trim()) {
        return optionName.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    var svgTitle = btn.querySelector('svg title');
    if (svgTitle && svgTitle.textContent.replace(/\s+/g, ' ').trim()) {
      return svgTitle.textContent.replace(/\s+/g, ' ').trim();
    }

    return '';
  }

  function isTextLikeInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    var type = (el.getAttribute('type') || 'text').toLowerCase();
    return type === 'text' || type === 'search' || type === 'email' || type === 'tel' || type === 'url';
  }

  function isButtonLikeInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    var type = (el.getAttribute('type') || '').toLowerCase();
    return type === 'button' || type === 'submit' || type === 'image' || type === 'reset';
  }

  /** Move inline onclick to a listener so scanners stop flagging input[onclick] (F15/F54). */
  function moveInlineOnclickToListener(el) {
    if (!el || !el.hasAttribute('onclick')) return false;
    if (el.hasAttribute('data-lems-onclick-moved')) return true;
    var code = el.getAttribute('onclick');
    if (!code) return false;
    el.setAttribute('data-lems-onclick-moved', 'true');
    el.removeAttribute('onclick');
    el.addEventListener('click', function () {
      try {
        Function(code).call(el);
      } catch (err) {
        /* ignore broken third-party handlers */
      }
    });
    return true;
  }

  function ensureInputKeyboardFocusable(input) {
    if (!input || input.tagName !== 'INPUT') return;
    if (input.disabled) return;
    var tab = input.getAttribute('tabindex');
    if (tab === '-1') input.setAttribute('tabindex', '0');
  }

  function fixUnnamedButtons(root) {
    root.querySelectorAll('button, [role="button"]').forEach(function (btn) {
      if (btn.tagName === 'INPUT') return;

      if (btn.classList.contains('lems-gif-pause')) {
        btn.setAttribute('aria-label', deriveButtonLabel(btn));
        return;
      }

      if (buttonHasAccessibleName(btn)) return;
      if (btn.hasAttribute('data-lems-btn-label-managed')) return;

      var label = deriveButtonLabel(btn);
      if (!label) return;

      btn.setAttribute('aria-label', label);
      btn.setAttribute('data-lems-btn-label-managed', 'true');
    });
  }

  function fixLocallyWidgetAccessibility(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.lcly-pl-widget-parent, #lcly-button-0, [id^="lcly-button"]').forEach(function (widget) {
      widget.querySelectorAll('[role="button"]').forEach(function (el) {
        if (el.tagName === 'BUTTON') return;
        if (el.tagName === 'A' && el.getAttribute('href')) {
          el.removeAttribute('role');
          return;
        }
        if (el.tagName === 'INPUT' && isTextLikeInput(el)) {
          el.removeAttribute('role');
          return;
        }
        if (getFocusableDescendants(el).length) el.removeAttribute('role');
      });

      widget.querySelectorAll('input[onclick], input.lcly-location-switcher-input, input[type="text"][onclick]').forEach(function (input) {
        moveInlineOnclickToListener(input);
        ensureInputKeyboardFocusable(input);

        if (input.getAttribute('role') === 'button' && isTextLikeInput(input)) {
          input.removeAttribute('role');
        }

        var placeholder = (input.getAttribute('placeholder') || '').replace(/\s+/g, ' ').trim();
        var cityEl = widget.querySelector('.lcly-city-name');
        var city = cityEl ? cityEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var locationLabel = 'Enter your location';
        if (placeholder && placeholder !== 'Your Town') locationLabel = 'Location, ' + placeholder;
        else if (city && city !== 'Your Town') locationLabel = 'Location, ' + city;

        input.removeAttribute('aria-labelledby');
        if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', locationLabel);
      });

      widget.querySelectorAll('input.lcly-location-switcher-button, input[type="submit"][onclick], input[type="button"][onclick]').forEach(function (btn) {
        moveInlineOnclickToListener(btn);
        ensureInputKeyboardFocusable(btn);
        if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Change location');
        if (isButtonLikeInput(btn) && !btn.hasAttribute('role')) {
          /* native submit/button inputs already have an implicit role */
        }
      });

      widget.querySelectorAll('button, [role="button"]').forEach(function (btn) {
        if (btn.tagName === 'INPUT') return;
        if (buttonHasAccessibleName(btn)) return;
        var label = deriveButtonLabel(btn);
        if (!label) return;
        btn.setAttribute('aria-label', label);
        btn.setAttribute('data-lems-btn-label-managed', 'true');
      });
    });

    scope.querySelectorAll('#lcly-iframe-outer-0[onclick], [id^="lcly-iframe-outer"][onclick]').forEach(function (overlay) {
      if (!overlay.getAttribute('role')) overlay.setAttribute('role', 'button');
      if (!overlay.hasAttribute('tabindex')) overlay.setAttribute('tabindex', '0');
      if (!buttonHasAccessibleName(overlay)) {
        overlay.setAttribute('aria-label', 'Close retailer finder');
      }
      bindClickableKeyboard(overlay);
    });

    /* Catch any remaining Locally/third-party input[onclick] in this root (incl. late inject). */
    scope.querySelectorAll('input[onclick]').forEach(function (input) {
      moveInlineOnclickToListener(input);
      ensureInputKeyboardFocusable(input);
      if (isButtonLikeInput(input)) {
        if (!hasAccessibleLabel(input) && !buttonHasAccessibleName(input)) {
          input.setAttribute('aria-label', deriveControlLabel(input) || 'Button');
        }
      } else if (isTextLikeInput(input) && !input.getAttribute('aria-label')) {
        input.setAttribute('aria-label', deriveControlLabel(input) || 'Input');
      }
    });
  }

  function fixAnimatedGifs(root) {
    /* GIF play/pause + autoplay is owned by layout/theme.liquid (gif-pause-btn).
       Do not wrap/replace product or homepage GIFs here — that hid or froze them. */
  }

  function hasAccessibleLabel(control) {
    if (!control || control.nodeType !== 1) return true;
    if (control.getAttribute('aria-label') || control.getAttribute('aria-labelledby')) return true;
    if (control.tagName === 'INPUT') {
      var inputType = (control.getAttribute('type') || '').toLowerCase();
      if ((inputType === 'submit' || inputType === 'button') && control.getAttribute('value')) return true;
    }
    if (control.labels && control.labels.length) return true;
    if (control.id) {
      var byFor = document.querySelector('label[for="' + CSS.escape(control.id) + '"]');
      if (byFor && byFor.textContent.replace(/\s+/g, ' ').trim()) return true;
    }
    if (control.closest('label')) return true;
    return false;
  }

  function deriveControlLabel(control) {
    var labelledBy = control.getAttribute('aria-labelledby');
    if (labelledBy) {
      var parts = labelledBy.split(/\s+/).map(function (id) {
        var el = document.getElementById(id);
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
      }).filter(Boolean);
      if (parts.length) return parts.join(' ');
    }

    var parentLabel = control.closest('label');
    if (parentLabel) {
      var clone = parentLabel.cloneNode(true);
      clone.querySelectorAll('select, input, textarea').forEach(function (node) {
        node.remove();
      });
      var parentText = clone.textContent.replace(/\s+/g, ' ').trim();
      if (parentText) return parentText;
    }

    var prev = control.previousElementSibling;
    if (prev && /^(LABEL|SPAN|P|DIV)$/i.test(prev.tagName)) {
      var prevText = prev.textContent.replace(/\s+/g, ' ').trim();
      if (prevText && prevText.length < 80) return prevText;
    }

    var ctx = [
      control.getAttribute('name') || '',
      control.getAttribute('id') || '',
      control.className || '',
      control.getAttribute('placeholder') || ''
    ].join(' ');

    if (/country|nation|region/i.test(ctx)) return 'Country';
    if (/locale|language|lang/i.test(ctx)) return 'Language';
    if (/sort/i.test(ctx)) return 'Sort by';
    if (/currency/i.test(ctx)) return 'Currency';
    if (/variant|option/i.test(ctx)) return 'Product option';
    if (/lcly-location-switcher-button/i.test(ctx)) return 'Change location';
    if (/lcly-location-switcher-input/i.test(ctx)) {
      return control.getAttribute('placeholder') || 'Enter your location';
    }

    if (control.tagName === 'SELECT') {
      var opt = control.options[control.selectedIndex] || control.options[0];
      if (opt && opt.textContent.replace(/\s+/g, ' ').trim()) {
        return opt.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    if (control.getAttribute('placeholder')) {
      return control.getAttribute('placeholder');
    }

    return 'Select option';
  }

  function fixUnlabeledFormControls(root) {
    root.querySelectorAll('select, input:not([type="hidden"]), textarea').forEach(function (control) {
      if (hasAccessibleLabel(control)) return;
      control.setAttribute('aria-label', deriveControlLabel(control));
    });
  }

  function inferIframeTitle(iframe) {
    var src = (iframe.getAttribute('src') || '').toLowerCase();
    if (src.indexOf('web-pixels') !== -1) return 'Shopify analytics';
    if (src.indexOf('googletagmanager') !== -1) return 'Google Tag Manager';
    if (src.indexOf('youtube.com') !== -1 || src.indexOf('youtu.be') !== -1) return 'YouTube video player';
    if (src.indexOf('vimeo.com') !== -1) return 'Vimeo video player';
    if (src.indexOf('facebook') !== -1) return 'Facebook embed';
    if (src.indexOf('klaviyo') !== -1) return 'Klaviyo form';
    if (iframe.id) return iframe.id.replace(/[-_]+/g, ' ');
    return 'Embedded content';
  }

  function fixIframeTitles(root) {
    root.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (iframe) {
      iframe.setAttribute('title', inferIframeTitle(iframe));
    });
  }

  function fixLayoutTables(root) {
    root.querySelectorAll('table').forEach(function (table) {
      if (table.getAttribute('role') === 'presentation') return;
      if (table.querySelector('th, [role="columnheader"], [role="rowheader"]')) return;
      if (!table.querySelector('td, [role="cell"]')) return;
      table.setAttribute('role', 'presentation');
    });
  }

  function inferClickableRole(el) {
    var handler = el.getAttribute('onclick') || '';
    if (/location|window\.open|href/i.test(handler)) return 'link';
    return 'button';
  }

  function bindClickableKeyboard(el) {
    if (el.hasAttribute('data-lems-keydown-bound')) return;
    el.setAttribute('data-lems-keydown-bound', 'true');
    el.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      el.click();
    });
  }

  /**
   * Langify puts onclick on an outer div while an inner span is already role=button.
   * Auditors flag the outer div[onclick]. Move activation to the inner control and
   * strip onclick/role/tabindex/aria-label from the wrapper.
   */
  function fixLangifySwitchers(root) {
    root.querySelectorAll('.ly-languages-switcher').forEach(function (switcher) {
      var toggle = switcher.querySelector('.ly-custom-dropdown-current');
      if (!toggle) return;

      if (switcher.hasAttribute('onclick')) {
        switcher.removeAttribute('onclick');
      }
      switcher.removeAttribute('role');
      switcher.removeAttribute('tabindex');
      switcher.removeAttribute('aria-label');
      switcher.removeAttribute('data-lems-a11y-clickable');
      switcher.removeAttribute('data-lems-keydown-bound');

      if (!toggle.getAttribute('role')) toggle.setAttribute('role', 'button');
      if (!toggle.hasAttribute('tabindex')) toggle.setAttribute('tabindex', '0');

      var currentText = toggle.querySelector('.ly-custom-dropdown-current-inner-text');
      var langName = currentText
        ? currentText.textContent.replace(/\s+/g, ' ').trim()
        : '';
      if (!toggle.getAttribute('aria-label') || /English English Spanish/i.test(toggle.getAttribute('aria-label') || '')) {
        toggle.setAttribute(
          'aria-label',
          langName ? 'Selected language: ' + langName : 'Language selector'
        );
      }

      if (toggle.hasAttribute('data-lems-ly-toggle-bound')) return;
      toggle.setAttribute('data-lems-ly-toggle-bound', 'true');

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (window.langify && langify.switcher && typeof langify.switcher.toggleSwitcherOpen === 'function') {
          langify.switcher.toggleSwitcherOpen(switcher);
        }
      });

      bindClickableKeyboard(toggle);
    });
  }

  function fixClickableNonInteractiveElements(root) {
    fixLangifySwitchers(root);

    /* Prefer neutralizing input[onclick] (Locally etc.) over role=button on text fields. */
    (root.querySelectorAll ? root : document).querySelectorAll('input[onclick]').forEach(function (input) {
      moveInlineOnclickToListener(input);
      ensureInputKeyboardFocusable(input);
    });

    root.querySelectorAll('div[onclick], span[onclick], a[onclick]').forEach(function (el) {
      if (el.hasAttribute('data-lems-a11y-clickable')) return;
      if (el.classList && el.classList.contains('ly-languages-switcher')) return;
      if (el.closest('.ly-languages-switcher')) return;
      if (el.closest('button, summary')) return;

      el.setAttribute('data-lems-a11y-clickable', 'true');
      if (!el.hasAttribute('role')) {
        el.setAttribute('role', inferClickableRole(el));
      }
      if (!el.hasAttribute('tabindex') && el.tagName !== 'A') {
        el.setAttribute('tabindex', '0');
      } else if (el.tagName === 'A' && !el.getAttribute('href')) {
        el.setAttribute('tabindex', '0');
      } else if (el.tagName === 'A' && el.getAttribute('href') === '#') {
        el.setAttribute('role', el.getAttribute('role') || 'button');
      }
      if (!hasAccessibleLabel(el)) {
        var label =
          (el.getAttribute('aria-label') || '').trim() ||
          (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (label) el.setAttribute('aria-label', label.slice(0, 120));
      }
      bindClickableKeyboard(el);
    });
  }

  function patchShadowRoots(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        patch(el.shadowRoot);
        patchShadowRoots(el.shadowRoot);
      }
    });
  }

  function watchLateWidgets() {
    if (document.documentElement.hasAttribute('data-lems-late-watch')) return;
    document.documentElement.setAttribute('data-lems-late-watch', 'true');

    function retarget() {
      fixLocallyWidgetAccessibility(document);
      fixClickableNonInteractiveElements(document);
      fixLangifySwitchers(document);
      patchShadowRoots(document);
    }

    var hosts = ['#lcly-button-0', '#lcly_shadow_root', '[data-oke-container]', '.oke-reviewsTab'];
    hosts.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el || el.hasAttribute('data-lems-watched')) return;
      el.setAttribute('data-lems-watched', 'true');
      new MutationObserver(retarget).observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['onclick', 'tabindex', 'role', 'aria-hidden']
      });
      if (el.shadowRoot) {
        new MutationObserver(retarget).observe(el.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['onclick', 'tabindex', 'role']
        });
      }
    });
  }

  function fixEmptyHeadings(root) {
    root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      if (heading.hasAttribute('data-lems-heading-fixed')) return;
      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) return;

      var img = heading.querySelector('img[alt]');
      var imgAlt = img ? (img.getAttribute('alt') || '').trim() : '';
      var link = heading.querySelector('a[aria-label]');
      var linkLabel = link ? (link.getAttribute('aria-label') || '').trim() : '';
      var name = imgAlt || linkLabel || 'Lems Shoes';

      heading.setAttribute('data-lems-heading-fixed', 'true');
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = name;
      heading.appendChild(sr);

      if (img) img.setAttribute('alt', '');
      if (link) link.removeAttribute('aria-label');
    });
  }

  function defocusElement(el) {
    if (!el.hasAttribute('data-lems-tabindex')) {
      el.setAttribute(
        'data-lems-tabindex',
        el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'native'
      );
    }
    el.setAttribute('tabindex', '-1');
    el.removeAttribute('aria-hidden');
    el.removeAttribute('data-a11y-hidden-managed');
  }

  function refocusElement(el) {
    if (!el.hasAttribute('data-lems-tabindex')) {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-a11y-hidden-managed');
      return;
    }
    var prev = el.getAttribute('data-lems-tabindex');
    if (prev === 'native') el.removeAttribute('tabindex');
    else el.setAttribute('tabindex', prev);
    el.removeAttribute('data-lems-tabindex');
    el.removeAttribute('aria-hidden');
    el.removeAttribute('data-a11y-hidden-managed');
  }

  function syncAriaHiddenContainer(container) {
    if (!container || container.nodeType !== 1) return;

    var hidden = container.getAttribute('aria-hidden') === 'true';

    if (hidden && container.matches && container.matches(FOCUSABLE_SELECTOR)) {
      defocusElement(container);
    } else if (!hidden && container.hasAttribute('data-lems-tabindex')) {
      refocusElement(container);
    }

    var focusables = container.querySelectorAll(FOCUSABLE_SELECTOR);

    if ('inert' in container) {
      container.inert = hidden && focusables.length > 0;
    }

    focusables.forEach(function (el) {
      if (hidden) defocusElement(el);
      else refocusElement(el);
    });
  }

  function fixAriaHiddenFocusables(root) {
    root.querySelectorAll('.slick-slide, .lems-okr-slide, [data-slick-index]').forEach(syncAriaHiddenContainer);
    root.querySelectorAll('[aria-hidden="true"]:not(.slick-slide):not(.lems-okr-slide)').forEach(syncAriaHiddenContainer);
    root.querySelectorAll('[aria-hidden="false"]').forEach(syncAriaHiddenContainer);
  }

  function fixDuplicateIds() {
    var idMap = Object.create(null);

    document.querySelectorAll('[id]').forEach(function (el) {
      var id = el.id;
      if (!id) return;
      if (!idMap[id]) idMap[id] = [];
      idMap[id].push(el);
    });

    Object.keys(idMap).forEach(function (id) {
      var elements = idMap[id];
      if (elements.length < 2) return;
      for (var i = 1; i < elements.length; i += 1) {
        elements[i].id = id + '-' + (i + 1);
      }
    });
  }

  function fixSlickTrackAria(root) {
    root.querySelectorAll('.slick-track[aria-label]').forEach(function (el) {
      el.removeAttribute('aria-label');
    });
  }

  function fixProductVideoPlayControls(root) {
    root.querySelectorAll('.video-title-wrapper, #video-play-button').forEach(function (el) {
      if (el.tagName === 'BUTTON') return;
      if (el.hasAttribute('data-lems-video-play-managed')) return;
      el.setAttribute('data-lems-video-play-managed', 'true');
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        var labelEl = el.querySelector('#play-button, .play-button');
        var label = labelEl ? labelEl.textContent.replace(/\s+/g, ' ').trim() : '';
        el.setAttribute('aria-label', label || 'Play detail video');
      }
      bindClickableKeyboard(el);
    });

    root.querySelectorAll('a#play-button:not([href]), a#play-button[href=""]').forEach(function (el) {
      if (el.hasAttribute('data-lems-video-play-managed')) return;
      el.setAttribute('data-lems-video-play-managed', 'true');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim() || 'Play detail video');
      }
      bindClickableKeyboard(el);
    });
  }

  function fixStarRatingLabels(root) {
    root.querySelectorAll('.lems-okr-stars[aria-label]:not([role])').forEach(function (el) {
      el.setAttribute('role', 'img');
    });
  }

  /**
   * ARIA 1.2: aria-label / aria-labelledby are prohibited on generic and
   * other non-naming roles. Promote interactive generics to role=button, else strip.
   */
  var PROHIBITED_NAMING_ROLES = {
    caption: true,
    code: true,
    deletion: true,
    emphasis: true,
    generic: true,
    insertion: true,
    paragraph: true,
    presentation: true,
    none: true,
    strong: true,
    subscript: true,
    superscript: true
  };

  function fixProhibitedAriaNames(root) {
    root.querySelectorAll('[aria-label], [aria-labelledby]').forEach(function (el) {
      if (el.closest('svg')) return;

      var role = (el.getAttribute('role') || '').toLowerCase().trim();
      var tag = el.tagName;
      if (!role && (tag === 'DIV' || tag === 'SPAN')) {
        role = 'generic';
      }
      if (!PROHIBITED_NAMING_ROLES[role]) return;

      var tabindex = el.getAttribute('tabindex');
      var interactive =
        el.hasAttribute('onclick') ||
        (tabindex !== null && tabindex !== '-1') ||
        (el.classList &&
          (el.classList.contains('cross-sells-continue-shopping') ||
            el.classList.contains('modal__toggle') ||
            el.classList.contains('video-title-wrapper')));

      if (interactive && (tag === 'DIV' || tag === 'SPAN')) {
        el.setAttribute('role', 'button');
        if (tabindex === null) el.setAttribute('tabindex', '0');
        return;
      }

      el.removeAttribute('aria-label');
      el.removeAttribute('aria-labelledby');
    });
  }

  function bindSlickAccessibility() {
    if (!window.jQuery) return;
    window.jQuery(document).on('init afterChange reInit setPosition', '.slick-slider', function () {
      fixAriaHiddenFocusables(this);
      fixSlickTrackAria(this);
      fixUnnamedButtons(this);
    });
  }

  function patch(root) {
    if (!root || !root.querySelectorAll) return;
    fixInvalidRoles(root);
    fixSummaryRoles(root);
    fixPresentationalRoleConflicts(root);
    fixRtlLanguages(root);
    fixLinkAccessibleNames(root);
    fixBadImageAlts(root);
    fixPlaceholderImageAlts(root);
    fixFieldsetLegends(root);
    fixInvalidListStructure(root);
    fixUnnamedButtons(root);
    fixAnimatedGifs(root);
    fixProductVideoPlayControls(root);
    fixAutoplayVideoPauseControls(root);
    fixClickableNonInteractiveElements(root);
    fixEmptyHeadings(root);
    fixLocallyWidgetAccessibility(root);
    fixUnlabeledFormControls(root);
    fixLayoutTables(root);
    fixIframeTitles(root);
    fixAriaHiddenFocusables(root);
    fixSlickTrackAria(root);
    fixStarRatingLabels(root);
    fixProhibitedAriaNames(root);
    fixDuplicateIds();
    root.querySelectorAll('video').forEach(ensureVideoCaptions);
    patchShadowRoots(root);
    watchLateWidgets();
    scheduleOverlaySync();
  }

  /**
   * First-load focus order: cookie bar → Klaviyo popup → site.
   * Both can stay visible; cookie gets focus/tab priority while open.
   */
  var COOKIE_BANNER_SELECTORS = [
    '#shopify-pc__banner',
    '#shopify-pc__banner__dialog',
    '.shopify-pc__banner',
    '.shopify-pc__banner__dialog',
    '#shopify-pc__banner__btn-accept',
    '#shopify-pc__banner__btn-decline',
    'button.shopify-pc__banner__btn-accept',
    'button.shopify-pc__banner__btn-decline',
    '#CybotCookiebotDialog',
    '#onetrust-banner-sdk',
    '#onetrust-consent-sdk',
    '.osano-cm-window',
    '.osano-cm-dialog',
    '#cky-consent-container',
    '.cky-consent-container',
    '#pandectes-banner',
    '.pandectes-banner',
    '[class*="cookie-banner"]',
    '[class*="cookie_banner"]',
    '[class*="cookie-consent"]'
  ];

  var overlayOrderState = {
    bound: false,
    syncing: false,
    scheduled: null,
    focusedCookie: false,
    focusedKlaviyo: false,
    bisTriggerBound: false,
    bisLock: false,
    lastSignature: '',
    styleInjected: false
  };

  function ensureOverlayOrderStyles() {
    if (overlayOrderState.styleInjected) return;
    overlayOrderState.styleInjected = true;
    var style = document.createElement('style');
    style.setAttribute('data-lems-overlay-order', 'true');
    /* Keep cookie above Klaviyo for clicking; do not hide Klaviyo */
    style.textContent =
      '#shopify-pc__banner,' +
      '#shopify-pc__banner .shopify-pc__banner__dialog,' +
      '.shopify-pc__banner,' +
      '.shopify-pc__banner__dialog{' +
      'z-index:2147483000!important;' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  }

  function isElementVisible(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (!style || style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function getFocusableElements(container) {
    if (!container || !container.querySelectorAll) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE_SELECTOR), function (el) {
      if (el.hasAttribute('disabled')) return false;
      if (el.getAttribute('tabindex') === '-1' && !el.matches('a[href], button, input, select, textarea')) {
        return false;
      }
      return isElementVisible(el);
    });
  }

  function setSubtreeInert(el, inert) {
    if (!el) return;
    var want = !!inert;
    var isInert = el.hasAttribute('data-lems-overlay-inert');
    if (want === isInert && (!('inert' in el) || el.inert === want)) return;
    if ('inert' in el) el.inert = want;
    if (want) el.setAttribute('data-lems-overlay-inert', 'true');
    else el.removeAttribute('data-lems-overlay-inert');
  }

  function getCookieBanner() {
    var direct = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (direct) {
      var directStyle = window.getComputedStyle(direct);
      if (directStyle.display !== 'none' && directStyle.visibility !== 'hidden') {
        return direct;
      }
    }

    for (var i = 0; i < COOKIE_BANNER_SELECTORS.length; i++) {
      try {
        var el = document.querySelector(COOKIE_BANNER_SELECTORS[i]);
        if (!el) continue;
        var root =
          el.closest(
            '#shopify-pc__banner, .shopify-pc__banner, #onetrust-consent-sdk, #onetrust-banner-sdk, .cky-consent-container, .osano-cm-window'
          ) || el;
        var style = window.getComputedStyle(root);
        if (style.display === 'none' || style.visibility === 'hidden') continue;
        return root;
      } catch (e) {}
    }
    return null;
  }

  function isKlaviyoTeaser(el) {
    if (!el || el.nodeType !== 1) return false;
    var cls = String(el.className || '');
    if (cls.indexOf('kl-teaser') !== -1) return true;
    if (el.closest && el.closest('[class*="kl-teaser"]')) return true;
    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed' && style.position !== 'absolute') return false;
    var rect = el.getBoundingClientRect();
    if (rect.height <= 0 || rect.height >= 140) return false;
    var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
    return text.indexOf('EXCLUSIVE ACCESS') !== -1;
  }

  function isKlaviyoPopupCandidate(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isKlaviyoTeaser(el)) return false;
    if (
      el.closest(
        '[data-lems-klaviyo-mount], footer, .footer, .footer-brand-stack__klaviyo, .klaviyo-form-wrapper, #shopify-pc__banner, .shopify-pc__banner, [class*="kl-teaser"]'
      )
    ) {
      return false;
    }
    var style = window.getComputedStyle(el);
    var z = parseInt(style.zIndex, 10) || 0;
    var rect = el.getBoundingClientRect();
    if (rect.height > 0 && rect.height < 120 && rect.width < 420) return false;
    if (el.getAttribute('role') === 'dialog') return true;
    if (style.position === 'fixed' && z >= 100 && rect.height >= 200) return true;
    if (style.position === 'fixed' && rect.height > 200) return true;
    return false;
  }

  function getKlaviyoPopups() {
    var results = [];
    var seen = {};

    function add(el) {
      if (!el || seen[el]) return;
      if (!isKlaviyoPopupCandidate(el)) return;
      if (!isElementVisible(el)) return;
      seen[el] = true;
      results.push(el);
    }

    document.querySelectorAll('.needsclick, [class*="klaviyo-form-"]').forEach(add);
    return results.slice(0, 5);
  }

  function getKlaviyoTeasers() {
    var results = [];
    var seen = {};
    document.querySelectorAll('.needsclick, [class*="kl-teaser"]').forEach(function (el) {
      if (!el || seen[el]) return;
      if (!isKlaviyoTeaser(el)) return;
      if (!isElementVisible(el) && el.getAttribute('data-lems-teaser-nofocus') !== 'true') return;
      seen[el] = true;
      results.push(el);
    });
    return results;
  }

  /** EXCLUSIVE ACCESS teaser: keep mouse-clickable, remove from keyboard tab order. */
  function defocusKlaviyoTeasers() {
    getKlaviyoTeasers().forEach(function (teaser) {
      teaser.setAttribute('data-lems-teaser-nofocus', 'true');
      teaser.setAttribute('tabindex', '-1');
      teaser.querySelectorAll(FOCUSABLE_SELECTOR).forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      if (document.activeElement && teaser.contains(document.activeElement)) {
        try {
          document.activeElement.blur();
        } catch (e) {}
      }
    });
  }

  function getSiteShellNodes() {
    var nodes = [];
    ['#MainContent', 'header', '#shopify-section-header', 'footer', '#shopify-section-footer'].forEach(
      function (sel) {
        var el = document.querySelector(sel);
        if (el && nodes.indexOf(el) === -1) nodes.push(el);
      }
    );
    return nodes;
  }

  function focusFirstIn(container) {
    if (!container) return;
    if (overlayOrderState.bisLock || isBisPopupOpen()) return;
    var focusables = getFocusableElements(container);
    var target = focusables[0];
    if (!target) return;
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      try {
        target.focus();
      } catch (err) {}
    }
  }

  function clearDeferredKlaviyoMarks() {
    document.querySelectorAll('[data-lems-klaviyo-deferred]').forEach(function (el) {
      el.removeAttribute('data-lems-klaviyo-deferred');
    });
  }

  function shieldCookieClicksFromKlaviyo(cookie) {
    if (!cookie || cookie.getAttribute('data-lems-click-shield') === 'true') return;
    cookie.setAttribute('data-lems-click-shield', 'true');
    /* Bubble phase: button handlers already ran; stop before document (Klaviyo outside-click). */
    function stopBubble(e) {
      e.stopPropagation();
    }
    ['mousedown', 'mouseup', 'click', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach(function (type) {
      cookie.addEventListener(type, stopBubble, false);
    });
  }

  function syncFirstLoadOverlayOrder() {
    if (overlayOrderState.syncing) return;
    overlayOrderState.syncing = true;
    try {
      ensureOverlayOrderStyles();
      clearDeferredKlaviyoMarks();

      var siteNodes = getSiteShellNodes();

      /* BIS popup open: inert page chrome around the iframe; never steal focus */
      if (overlayOrderState.bisLock || isBisPopupOpen()) {
        siteNodes.forEach(function (node) {
          setSubtreeInert(node, false);
        });
        setBisBackgroundInert(true);
        return;
      }

      var cookie = getCookieBanner();
      var klaviyoPopups = getKlaviyoPopups();

      /* EXCLUSIVE ACCESS flyout must not steal focus after/with the modal popup */
      defocusKlaviyoTeasers();

      if (cookie) {
        shieldCookieClicksFromKlaviyo(cookie);
        /*
          Do NOT inert Klaviyo while cookie is open — inert makes clicks pass through
          the popup and Klaviyo treats that as an outside click (closes itself).
          Only block site chrome + trap keyboard focus on the cookie bar.
        */
        klaviyoPopups.forEach(function (popup) {
          setSubtreeInert(popup, false);
        });
        siteNodes.forEach(function (node) {
          setSubtreeInert(node, true);
        });
        setSubtreeInert(cookie, false);
        if (!overlayOrderState.focusedCookie) {
          overlayOrderState.focusedCookie = true;
          window.setTimeout(function () {
            if (overlayOrderState.bisLock || isBisPopupOpen()) return;
            if (getCookieBanner()) focusFirstIn(cookie);
          }, 100);
        }
        return;
      }

      klaviyoPopups.forEach(function (popup) {
        setSubtreeInert(popup, false);
      });

      if (klaviyoPopups.length) {
        siteNodes.forEach(function (node) {
          setSubtreeInert(node, true);
        });
        if (!overlayOrderState.focusedKlaviyo) {
          overlayOrderState.focusedKlaviyo = true;
          window.setTimeout(function () {
            if (overlayOrderState.bisLock || isBisPopupOpen()) return;
            var live = getKlaviyoPopups();
            if (live.length) focusFirstIn(live[0]);
          }, 150);
        }
        return;
      }

      siteNodes.forEach(function (node) {
        setSubtreeInert(node, false);
      });
    } finally {
      overlayOrderState.syncing = false;
    }
  }

  function scheduleOverlaySync() {
    if (overlayOrderState.syncing) return;
    if (overlayOrderState.scheduled) return;
    overlayOrderState.scheduled = window.setTimeout(function () {
      overlayOrderState.scheduled = null;
      syncFirstLoadOverlayOrder();
    }, 250);
  }

  function isBisPopupOpen() {
    var frame = document.getElementById('BIS_frame');
    if (!frame) return false;
    var style = window.getComputedStyle(frame);
    return !!(style && style.display !== 'none' && style.visibility !== 'hidden');
  }

  /*
    Stop calling .focus() inside #BIS_frame — that fought BIS (email → ✕ → page).
    While open, inert the rest of the page so focus cannot leave the iframe.
    BIS keeps its own focus (usually email).
  */
  function setBisBackgroundInert(on) {
    var frame = document.getElementById('BIS_frame');
    if (!frame || !document.body) return;

    var node = frame;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sib) {
        if (sib === node) return;
        if (on) {
          if ('inert' in sib) sib.inert = true;
          sib.setAttribute('data-lems-bis-bg-inert', 'true');
        } else if (sib.getAttribute('data-lems-bis-bg-inert') === 'true') {
          if ('inert' in sib) sib.inert = false;
          sib.removeAttribute('data-lems-bis-bg-inert');
        }
      });
      node = parent;
    }

    if ('inert' in frame) frame.inert = false;
    frame.removeAttribute('data-lems-bis-bg-inert');
  }

  /** ✕ is a <span role="button"> — wire Enter/Space to click (native <button> would do this). */
  function enhanceBisCloseKeyboard() {
    var frame = document.getElementById('BIS_frame');
    if (!frame || !isBisPopupOpen()) return;
    var doc;
    try {
      doc = frame.contentDocument || (frame.contentWindow && frame.contentWindow.document);
    } catch (e) {
      return;
    }
    if (!doc) return;

    doc.querySelectorAll('.close.action-close, .action-close, [aria-label="Close Dialog"]').forEach(function (el) {
      if (el.getAttribute('data-lems-bis-key-close') === 'true') return;
      el.setAttribute('data-lems-bis-key-close', 'true');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');

      el.addEventListener('keydown', function (event) {
        var key = event.key || event.code;
        if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar' && key !== 'Space') return;
        event.preventDefault();
        event.stopPropagation();
        try {
          el.click();
        } catch (err) {
          try {
            el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          } catch (err2) {}
        }
      });
    });
  }

  function bindBisTriggerCloseFocus() {
    if (overlayOrderState.bisTriggerBound) return;
    overlayOrderState.bisTriggerBound = true;
    var watchTimer = null;
    var closedStrikes = 0;
    var lastBisTrigger = null;

    function focusBisTrigger() {
      var trigger =
        lastBisTrigger ||
        document.getElementById('BIS_trigger') ||
        document.querySelector('.BIS_trigger, .BIS-cta');
      if (!trigger || !trigger.focus) return;
      try {
        trigger.focus({ preventScroll: true });
      } catch (e) {
        try {
          trigger.focus();
        } catch (e2) {}
      }
    }

    function endBisLock() {
      overlayOrderState.bisLock = false;
      setBisBackgroundInert(false);
      getSiteShellNodes().forEach(function (node) {
        setSubtreeInert(node, false);
      });
      scheduleOverlaySync();
      // After inert is cleared, return focus to the Notify Me control that opened BIS.
      window.setTimeout(focusBisTrigger, 0);
      window.setTimeout(function () {
        focusBisTrigger();
        lastBisTrigger = null;
      }, 50);
    }

    function onBisOpenTick() {
      setBisBackgroundInert(true);
      enhanceBisCloseKeyboard();
    }

    function watchUntilClosed() {
      closedStrikes = 0;
      if (watchTimer) window.clearInterval(watchTimer);
      watchTimer = window.setInterval(function () {
        if (isBisPopupOpen()) {
          closedStrikes = 0;
          onBisOpenTick();
          return;
        }
        closedStrikes += 1;
        if (closedStrikes === 1) {
          // Popup just closed — restore focus immediately; finish cleanup after a few stable ticks.
          setBisBackgroundInert(false);
          focusBisTrigger();
        }
        if (closedStrikes < 3) return;
        window.clearInterval(watchTimer);
        watchTimer = null;
        endBisLock();
      }, 400);
    }

    function onBisTriggerClick(triggerEl) {
      lastBisTrigger = triggerEl || lastBisTrigger;
      overlayOrderState.bisLock = true;
      closedStrikes = 0;
      getSiteShellNodes().forEach(function (node) {
        setSubtreeInert(node, false);
      });
      scheduleOverlaySync();
      window.setTimeout(function () {
        if (overlayOrderState.bisLock) onBisOpenTick();
      }, 50);
      window.setTimeout(function () {
        if (overlayOrderState.bisLock) onBisOpenTick();
      }, 400);
      window.setTimeout(function () {
        if (overlayOrderState.bisLock) enhanceBisCloseKeyboard();
      }, 800);
      watchUntilClosed();
    }

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var trigger = t.closest('#BIS_trigger, .BIS_trigger, .BIS-cta');
        if (trigger) {
          onBisTriggerClick(trigger);
        }
      },
      true
    );
  }

  function bindFirstLoadOverlayOrder() {
    if (overlayOrderState.bound) return;
    overlayOrderState.bound = true;
    ensureOverlayOrderStyles();
    bindBisTriggerCloseFocus();

    document.addEventListener(
      'focusin',
      function (event) {
        if (overlayOrderState.syncing) return;
        if (overlayOrderState.bisLock || isBisPopupOpen()) return;
        var cookie = getCookieBanner();
        if (!cookie) return;
        if (cookie.contains(event.target)) return;
        focusFirstIn(cookie);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Tab') return;
        if (overlayOrderState.bisLock || isBisPopupOpen()) return;
        var cookie = getCookieBanner();
        if (cookie) {
          var focusables = getFocusableElements(cookie);
          if (!focusables.length) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          var active = document.activeElement;
          if (!cookie.contains(active)) {
            event.preventDefault();
            first.focus();
            return;
          }
          if (event.shiftKey && active === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && active === last) {
            event.preventDefault();
            first.focus();
          }
          return;
        }

        var popups = getKlaviyoPopups();
        if (!popups.length) return;
        var popup = popups[0];
        var popupFocusables = getFocusableElements(popup);
        if (!popupFocusables.length) return;
        var pFirst = popupFocusables[0];
        var pLast = popupFocusables[popupFocusables.length - 1];
        var pActive = document.activeElement;
        if (!popup.contains(pActive)) {
          event.preventDefault();
          pFirst.focus();
          return;
        }
        if (event.shiftKey && pActive === pFirst) {
          event.preventDefault();
          pLast.focus();
        } else if (!event.shiftKey && pActive === pLast) {
          event.preventDefault();
          pFirst.focus();
        }
      },
      true
    );

    document.addEventListener(
      'focusin',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var teaser = t.closest('[data-lems-teaser-nofocus="true"], [class*="kl-teaser"]');
        if (!teaser && isKlaviyoTeaser(t)) teaser = t;
        if (!teaser) return;
        defocusKlaviyoTeasers();
        try {
          t.blur();
        } catch (e) {}
        var cookie = getCookieBanner();
        if (cookie) {
          focusFirstIn(cookie);
          return;
        }
        var popups = getKlaviyoPopups();
        if (popups.length) {
          focusFirstIn(popups[0]);
          return;
        }
        var main = document.getElementById('MainContent') || document.querySelector('main');
        if (main) {
          if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
          try {
            main.focus({ preventScroll: true });
          } catch (err) {}
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (
          t.closest(
            '#shopify-pc__banner__btn-accept, #shopify-pc__banner__btn-decline, .shopify-pc__banner__btn-accept, .shopify-pc__banner__btn-decline, .shopify-pc__banner__btn-manage-prefs'
          )
        ) {
          window.setTimeout(scheduleOverlaySync, 100);
          window.setTimeout(scheduleOverlaySync, 400);
          window.setTimeout(scheduleOverlaySync, 1000);
        }
      },
      true
    );

    /*
      While cookie is open, stop Klaviyo's document outside-click closer.
      Do not block events that originate inside the Klaviyo form itself.
      Bubble phase so Accept/Decline still fire first.
    */
    function blockOutsideCloseWhileCookie(e) {
      var cookie = getCookieBanner();
      if (!cookie) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var popups = getKlaviyoPopups();
      for (var i = 0; i < popups.length; i++) {
        if (popups[i].contains(t)) return;
      }
      e.stopImmediatePropagation();
    }
    ['mousedown', 'mouseup', 'click', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach(
      function (type) {
        document.addEventListener(type, blockOutsideCloseWhileCookie, false);
      }
    );

    var overlayObserver = new MutationObserver(function () {
      scheduleOverlaySync();
    });
    overlayObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    [300, 800, 1600, 3200, 6000].forEach(function (ms) {
      window.setTimeout(scheduleOverlaySync, ms);
    });
  }

  function patchDocument() {
    patch(document);
    bindFirstLoadOverlayOrder();
    scheduleOverlaySync();
  }

  bindSlickAccessibility();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchDocument);
  } else {
    patchDocument();
  }

  window.setTimeout(patchDocument, 1000);
  window.setTimeout(patchDocument, 3000);
  window.setTimeout(patchDocument, 5000);
  window.setTimeout(patchDocument, 8000);
  window.setTimeout(patchDocument, 12000);
  window.setTimeout(patchDocument, 20000);

  window.lemsPatchA11y = patchDocument;

  var observer = new MutationObserver(function (mutations) {
    var needsFull = false;
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        var target = mutation.target;
        if (
          mutation.attributeName === 'aria-label' &&
          target.classList &&
          target.classList.contains('slick-track')
        ) {
          target.removeAttribute('aria-label');
          return;
        }
        if (
          mutation.attributeName === 'aria-label' ||
          mutation.attributeName === 'aria-labelledby'
        ) {
          if (target.nodeType === 1) {
            fixProhibitedAriaNames(target.parentNode || document);
          }
          return;
        }
        if (
          mutation.attributeName === 'role' &&
          target.tagName === 'SUMMARY' &&
          target.parentElement &&
          target.parentElement.tagName === 'DETAILS'
        ) {
          target.removeAttribute('role');
          return;
        }
        if (
          mutation.attributeName === 'aria-hidden' &&
          target.nodeType === 1
        ) {
          syncAriaHiddenContainer(target);
          if (
            target.classList &&
            (target.classList.contains('slick-slide') ||
              target.classList.contains('lems-okr-slide') ||
              target.hasAttribute('data-slick-index'))
          ) {
            fixAriaHiddenFocusables(target.parentElement || document);
          }
        }
        if (mutation.attributeName === 'onclick' && target.nodeType === 1) {
          if (target.tagName === 'INPUT') {
            moveInlineOnclickToListener(target);
            ensureInputKeyboardFocusable(target);
          }
          fixClickableNonInteractiveElements(target.parentElement || document);
          fixLocallyWidgetAccessibility(target.parentElement || document);
          return;
        }
        if (
          mutation.attributeName === 'alt' &&
          target.tagName === 'IMG' &&
          isBadImageAlt(target.getAttribute('alt'))
        ) {
          target.setAttribute('alt', deriveImageAlt(target));
          return;
        }
        if (
          mutation.attributeName === 'src' &&
          target.tagName === 'IMG'
        ) {
          fixBadImageAlts(target.parentElement || document);
          return;
        }
        return;
      }

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        patch(node);
        if (
          (node.id && String(node.id).indexOf('lcly') === 0) ||
          (node.className && String(node.className).indexOf('lcly') !== -1) ||
          (node.className && String(node.className).indexOf('oke') !== -1) ||
          (node.querySelector && node.querySelector('input[onclick], .ly-languages-switcher, #lcly-button-0'))
        ) {
          needsFull = true;
        }
      });
    });
    if (needsFull) {
      window.setTimeout(patchDocument, 50);
      window.setTimeout(patchDocument, 500);
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label', 'aria-hidden', 'role', 'tabindex', 'onclick', 'src', 'alt']
  });

  document.addEventListener('shopify:section:load', patchDocument);
})();
